import { SET_EMISSIONS } from 'redux/action/type'

interface IEmissionsState {
  scope1Emissions: any[]
  scope2Emissions: any[]
  scope3Emissions: any[]
  isLoading: boolean
}

interface EmissionAction {
  type: string
  payload: IEmissionsState
}

const initialState: IEmissionsState = {
  scope1Emissions: [],
  scope2Emissions: [],
  scope3Emissions: [],
  isLoading: false,
}

const emissionReducer = (
  state: IEmissionsState = initialState,
  action: EmissionAction,
): IEmissionsState => {
  switch (action.type) {
    case SET_EMISSIONS:
      return {
        ...state,
        scope1Emissions: action.payload.scope1Emissions,
      }
    default:
      return state
  }
}

export default emissionReducer
